var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"padding":"0px !important"},attrs:{"fluid":""}},[(_vm.visualizacao == 'produtos')?_c('ProdutoDescri'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }